import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
// import {MessageBox} from 'element-ui'
// import VCharts from 'v-charts'
import router from "./router"
import 'element-ui/lib/theme-chalk/display.css';
// hover css样式表
import './assets/hover.css'
// import iView from 'iview';
// import 'iview/dist/styles/iview.css';    // 使用 CSS

// 引入註冊全局方法
// import Utils from './js/utils/util.js';
// Vue.prototype.utils=Utils;
//調用方法
// this.utils.text();

import 'element-ui/lib/theme-chalk/index.css';
import Axios from "axios"
import qs from "qs"

// import 'babel-polyfill'

//录音机组件
// import AudioRecorder from 'vue-audio-recorder'

//题库分析表中的图表页面
// import ChartsPage from '@/components/exam/ChartsPage.vue'


// import ListPage from '@/components/page/ListPage.vue'
// import TreePage from '@/components/page/TreePage.vue'
// import AddOrUpPage from '@/components/page/AddOrUpPage.vue'
// import AddOrUpFieldTmp from '@/components/page/AddOrUpFieldTmp.vue'
// import ListSearch from '@/components/page/ListSearch.vue'
// 排课 课表的组件
// import TimeTable from '@/components/page/TimeTable.vue'
//树形报表的组件
// import TreeChart from '@/components/page/TreeChart.vue'
//数据报表组件
// import Report from '@/components/page/report/Report.vue'
// import Report from '@/components/page/Report.vue'
//阿里云播放器组件
// import VueAliplayer from '@/components/live/VueAliplayer.vue'
//引入阿里云播放器
// import VueAliplayer from "vue-aliplayer";
//直播间组件
// import LiveRoom from '@/components/live/LiveRoom.vue'
//试题组件
// import Question from '@/components/exam/Question.vue'
//试卷组件
// import ExamPaper from '@/components/exam/ExamPaper.vue'
//学员做试题
// import DoQuestion from '@/components/exam/DoQuestion.vue'
//学员做试卷 
// import DoExamPaper from '@/components/exam/DoExamPaper.vue'
//音频录制组件
// import Record from '@/components/live/Record.vue'
// 登录组件
// import LoginPage from '@/pages/login/LoginPage.vue'
// 注册组件
// import LogonPage from '@/pages/login/LogonPage.vue'

//阿里图标
import './assets/iconfont/iconfont.css'

//商城 网站底部内容
// import asFooter from '@/components/footer/footer.vue';
//商城 网站头部内容
// import ShopTop from '@/components/shopping/ShopTop.vue';
//PC考试底部内容
// import examinationFooter from '@/components/footer/examinationFooter.vue';
//PC考试头部内容
// import examinationHeader from '@/components/header/examinationHeader.vue';

//知识树组件
// import KnowledgeTree from '@/components/exam/KnowledgeTree.vue';
//日历课表组件
// import Schedule from '@/components/page/Schedule.vue'

// 添加修改查看页面 组件
// import kw_look from '@/components/look/kw_look.vue'
// // 列表页面的查看页面 组件
// import kw_list from '@/components/list/kw_list.vue'



// 腾讯 云直播/////////////////////////////////////////////////////////////////////////////////
// import store from '@/components/liveTxy/store/index'
// import TWebLive from 'tweblive' 
// import im from '@/components/liveTxy/tim'
// import { showVconsole } from '@/components/liveTxy/utils/vconsole'
// import '@/components/liveTxy/assets/icon/iconfont.css'
// import '@/components/liveTxy/assets/icon/tim.css'
// import '@/components/liveTxy/assets/css/reset.css'
// import '@/components/liveTxy/assets/css/animate.css'
// window.im = im
// window.TWebLive = TWebLive
// window.store = store
// Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。
// // Vue.prototype.im = im
// Vue.prototype.TWebLive = TWebLive
// Vue.prototype.$store = store
// Vue.prototype.qrcode = QRCode
// Vue.prototype.$confirm = MessageBox.confirm

// import QRCode from 'qrcode'
// Vue.use(QRCode)

// showVconsole(false)

// 腾讯 云直播//////////////////////////////////////////////////////////////////////////////////////////


// import VueContextMenu from 'vue-contextmenu'
// import 'vue-contextmenu/style/css/font-awesome.min.css'
//ant组件 日历组件
// import { Calendar } from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.css'
//图片预览组件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Viewer.setDefaults({
  Options: { "zIndex": 9999,"inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

// Vue.use(iView);

// import theConfirm from '../public/confirm/confirm.js'
// Vue.prototype.$confirmTips = theConfirm;

// Vue.use(Calendar)
// Vue.use(VueContextMenu)
import GLOBAL from '@/components/customInfo/Global.vue'
Vue.prototype.$axios = Axios
Vue.prototype.GLOBAL = GLOBAL
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
Vue.prototype.pageUtils = pageUtils;
Vue.prototype.utils = utils;
Vue.use(ElementUI);
// Vue.use(VCharts);
// Vue.use(AudioRecorder);


import '@/js/utils/directives.js';

// import fitPlugs from '@/js/utils/el_table_fit/fit_columns.js';
// Vue.use(fitPlugs);

//vue-quill-editor 文本编辑器
//quill-editor
// import VueQuillEditor from '@/components/quill_editor/editor.vue'
// require styles

// import VueQuillEditor from 'quill'
// import VueUeditorWrap from '@/components/vue-ueditor-wrap.vue';



// Vue.component('vue-ueditor-wrap', VueUeditorWrap)
// Vue.component('quill-editor', VueQuillEditor)
// Vue.component('ListPage', ListPage)
// Vue.component('ChartsPage', ChartsPage)
// Vue.component('TreePage', TreePage)
// Vue.component('ListSearch', ListSearch)
// Vue.component('AddOrUpPage', AddOrUpPage)
// Vue.component('AddOrUpFieldTmp', AddOrUpFieldTmp)
// Vue.component('TimeTable', TimeTable)
// Vue.component('Report', Report)
// Vue.component('TreeChart', TreeChart)
// Vue.component('ali-player', VueAliplayer)
// Vue.component('LiveRoom', LiveRoom)
// Vue.component('Question', Question)
// Vue.component('ExamPaper', ExamPaper)
// Vue.component('DoQuestion', DoQuestion)
// Vue.component('DoExamPaper', DoExamPaper)
// Vue.component('Record', Record)
// Vue.component('LoginPage', LoginPage)
// Vue.component('asFooter', asFooter)
// Vue.component('examinationFooter', examinationFooter)
// Vue.component('examinationHeader', examinationHeader)
// Vue.component('ShopTop', ShopTop)
// Vue.component('KnowledgeTree', KnowledgeTree)
// Vue.component('LogonPage', LogonPage)
// Vue.component('Schedule', Schedule)
// Vue.component('kw_look', kw_look)
// Vue.component('kw_list', kw_list)
//打印组件加载
// import Print from 'vue-print-nb'
// Vue.use(Print);
// Vue.prototype.$print = Print

// import VueSignaturePad from "vue-signature-pad";

// Vue.use(VueSignaturePad);

// import pageUtils from '@/js/page/pageUtil.js';


Vue.config.productionTip = false

 //Axios.defaults.baseURL = 'http://192.168.6.32:8080/';

// Axios.defaults.baseURL = 'https://plat.keweisoft.com/kw_plat';
Axios.defaults.baseURL = '/kw_plat';

// Axios.defaults.baseURL = 'http://39.100.239.82/kw_plat';

// Axios.defaults.baseURL = 'https://www.culturalworldnet.com/kw_plat';
// Axios.defaults.baseURL = 'https://hmyzy.zgslyx.com/kw_plat/';
// Axios.defaults.baseURL = 'https://study.bailiedu.com/'+GLOBAL.projectName;

// Axios.defaults.baseURL = 'http://192.168.6.13:8080/edus_auto';


Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Axios.defaults.withCredentials=true;

// 拦截器
// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
  // config.data.sourceType = 1;
  // 在发送请求之前做些什么
  if(config.url.indexOf("OmFileUploadServlet") == -1 && config.url.indexOf("import_importTable") == -1 && config.url.indexOf("yozocloud") == -1) {
    if(config.method === "post"){
      config.data = qs.stringify(config.data,{arrayFormat: 'repeat'});
      // config.data += "&source=1";
    }
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
Axios.interceptors.response.use(function (response) {
  // console.log(response)
  // 对响应数据做点什么
  if(response.data == "未登陆,请先登陆"){
    //this.loginCheck = true;
    //跳转至登陆页面
    // router.push({
    //   name: 'LoginPage',
    //   params: {
    //   }
    // })
    // return {
    //   msg:"数据返回不合理"
    // }
  }
  return response;
}, function (error) {
  // 对响应错误做点什么
  console.log("error================", error);
  return error;
});

router.beforeEach((to, from, next) => {
  var toParam = to.params;
  var query = to.query;
  // if(to.name == "MailHome") {
    console.log("toParam=========================",to)
    if(toParam && toParam.domain_name) {
      localStorage.domain_name = toParam.domain_name;
    } else if(query && query.domain_name) {
      localStorage.domain_name = query.domain_name;
    }
    if(localStorage.domain_name == "default") {
      localStorage.domain_name = "";
    }
    console.log("localStorage.domain_name=========================",localStorage.domain_name)
    // else {
    //   sessionStorage.domain_name = "";
    // }
  // }
  // if(to.meta && to.meta.isShare){
      const agent = navigator.userAgent
      const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      //因为Android是兼容的，所以只需要判断是不是iOS终端
      if (isiOS && to.path !== location.pathname) {
        if(!sessionStorage.originUrl) {
          if(location.href.indexOf("code")>0) {
            sessionStorage.originUrl = location.href;
          }
        }
        // location.assign(to.fullPath)
      }
    if(to.name == from.name) {
      window.location.reload();
    }
  // }
  next();   
});

new Vue({
  el:'#app',
  components:{
    
  },
  router,
  render: h => h(App),
}).$mount('#app')
